import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { headerActions, fetchOpportunityById, referralActions, throwError } from '../../../actions';
import { HEADER } from '../../../constants';
import ContentLoader from 'components/common/loaders/ContentLoader';
import StatusBadge from '../../common/Fields/StatusBadge';
import { getEmailLink } from 'helpers/utilities';
import _ from 'lodash';

class DocumentRejected extends React.Component {
  static propTypes = {
    setHeader: PropTypes.func.isRequired,
    fetchOpportunity: PropTypes.func.isRequired,
    fetchContact: PropTypes.func.isRequired,
    throwError: PropTypes.func.isRequired,
    referralData: PropTypes.object,
    opportunityData: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object
  }

  componentDidMount = async () => {
    try {
      this.props.setHeader({
        type: HEADER.UPDATE_HEADER,
        showHeader: true,
        headerTitle: 'Document Rejected',
        hasBackButton: true,
        backButtonIcon: 'close',
        hasNotificationIcon: true
      });

      const contactId = _.get(this.props, 'match.params.contactId', null);
      const opportunityId = _.get(this.props, 'match.params.opportunityId', null);
      await Promise.all([
        this.props.fetchOpportunity(contactId, opportunityId),
        this.props.fetchContact(contactId)
      ]);
    } catch (err) {
      this.props.throwError('goback');
    }
  }

  render () {
    const opportunity = this.props.opportunityData || {};
    const contact = this.props.referralData || {};
    const documentName = _.get(this.props, 'location.state.documentName', '');
    const rejectionReason = _.get(this.props, 'location.state.rejectionReason', '');

    if (_.isEmpty(opportunity)) {
      return <ContentLoader isLoading />;
    }

    const opportunityType = opportunity.type === 'Buyer' ? 'buying' : 'selling';
    const fullName = `${_.get(contact, 'firstName', '')} ${_.get(contact, 'lastName', '')}`.trim();
    const stage = !opportunity.status ? 'No Status' : opportunity.status;

    return (
      <section className='page-content details-page document-rejected-page'>
        <div className='card card-block top-card-wrap'>
          <div className='profile-header-name'>
            <div className='text-profile-update text-profile-name'>{fullName}</div>
          </div>
          <div className='d-flex'>
            <div className='opportunity-icon'>
              <span className={`lead-type-badge lead-${opportunityType}`} />
            </div>
            <div className='lead-type-wrapper'>
              <div className='lead-type-text'>
                {`${opportunityType[0].toUpperCase()}${opportunityType.slice(1)}`}
              </div>
            </div>
          </div>
          <div className='opportunity-status-container'>
            <div className='status-badge'>
              <StatusBadge statusGroup={opportunity.group} />
            </div>
            <div className='opportunity-text-container'>
              <div className='status-label-text'>{stage}</div>
            </div>
          </div>
        </div>

        <div className='document-rejected-message px-3 py-2'>
          <p>{`Your document "${documentName}" has been rejected due to the following reason:`}</p>
          <div className='document-rejected-reason form-control'>
            {rejectionReason}
          </div>
          <div className='d-flex justify-content-between align-items-center mt-3'>
            <p className='mb-0'>Please upload the new document.</p>
            <div className='opportunity-icons'> EMAIL DOCS
              <a href={getEmailLink(opportunity.documentEmail)} target='_blank'><i className='material-icons material-icons-email ml-2' role='button' /></a>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => {
  const { referrals } = state;
  return {
    referralData: _.get(referrals, 'referralData', null),
    opportunityData: _.get(referrals, 'opportunityData', null)
  };
};

const mapDispatchToProps = dispatch => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  fetchOpportunity: bindActionCreators(fetchOpportunityById, dispatch),
  fetchContact: bindActionCreators(referralActions.fetchContactData, dispatch),
  throwError: bindActionCreators(throwError, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DocumentRejected));
